import { render, staticRenderFns } from "./CashierDashboard.vue?vue&type=template&id=94370604&scoped=true"
import script from "./CashierDashboard.vue?vue&type=script&lang=js"
export * from "./CashierDashboard.vue?vue&type=script&lang=js"
import style0 from "./CashierDashboard.vue?vue&type=style&index=0&id=94370604&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94370604",
  null
  
)

export default component.exports